app.service('basketUtils', function (console, modal, loading, cookie, orderConfig, orderUtils, message) {
	function calculateCart() {
		console.log('PRZELICZENIE KOSZYKA');
		skipValidation();
		incBacks();

		var voucher = $.trim($('#voucher-input').val());
		if (voucher.length > 0 && !/^[0-9a-zA-Z._-]+$/.test(voucher)) {
			modal.alert('Nieprawidłowe znaki w kodzie rabatowym');
			return false;
		}
		orderUtils.send('SAVE', true);
	}
	function incBacks() {
		$('#f_backs').val(($('#f_backs').val() / 1) + 1);
	}
	function skipValidation() {
		$('.js-delivery-type').ignore(true);
	}
	function needRefresh(callbackIfNotNeedRefresh, callbackIfNeedRefresh) {
		loading.start();
		console.log('SPRAWDZENIE KONIECZNOŚCI ODŚWIEŻENIA KOSZYKA');

		var config = orderConfig.getData();
		var data = {
			cartCookie: cookie.get("euroCart"),
			md5Sum: config.md5Sum
		};
		$.ajax({
			url: '/cartHashChecking.ltr',
			dataType: 'json',
			cache: false,
			data: data,
			success: function (json) {
				if (json.needRefresh) {
					if (callbackIfNeedRefresh) {
						callbackIfNeedRefresh()
					} 
					message.get('cart-needs-refresh-message').then(function (html) {
						modal.generate({
							content: html,
							id: 'cart-needs-refresh',
							callbackClose: function () { 
								loading.reload();
							},
							buttons: [{
								text: 'Rozumiem',
								cssClass: 'btn-second',
								click: function () {
									modal.close();
								}
							}]
						});
					});
				} else if (callbackIfNotNeedRefresh) {
					callbackIfNotNeedRefresh();
				}
			},
			error: function () {
				modal.alert('Wystąpił błąd weryfikacji koszyka. Sprawdź ponownie po odświeżeniu.', function () {
					loading.reload();
				});
			}
		});
	}
	return {
		calculateCart: calculateCart,
		incBacks: incBacks,
		needRefresh: needRefresh,
		skipValidation: skipValidation
	};
});
